<script lang="ts">
export default {
  name: 'ExportButton',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { Download } from 'lucide-vue-next';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppState } from '@/store';

// ---------------
// reactive data
// ---------------
const store = useStore<AppState>();

// ----------
// computed
// ----------
const exportListShowing = computed<boolean | undefined>(() => {
  return store?.state.towerVisualizerState.showExportOptions;
});

// ----------
// handlers
// ----------
function toggleExportOptions(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SHOW_VISUALIZER_EXPORT_OPTIONS, !store?.state.towerVisualizerState.showExportOptions);
}
</script>

<template>
  <div class="tw:py-2 tw:pr-2 tw:pl-1 tw:self-end">
    <label title="Export">
      <input
        type="checkbox"
        name="export-button"
        aria-label="Export Button"
        class="tw:box-border tw:pointer-events-none tw:hidden"
        @click="toggleExportOptions"
      /> <slot name="icon" :export-list-showing="exportListShowing">
      <div
          :class="{ selected: exportListShowing }"
          class="tw:bg-base-200 tw:border tw:border-solid tw:border-gray-300 tw:hover:bg-gray-300 tw:transition-all tw:flex tw:items-center tw:justify-center tw:cursor-pointer tw:pointer-events-auto tw:border-box tw:rounded-lg tw:shadow-lg tw:w-10 tw:h-10"
        >
          <Download :size="18" />
        </div>
      </slot>
    </label>
  </div>
</template>

<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}
</style>
